// API Configuration
// Update WORKER_URL to your Cloudflare Worker URL in production

const isDev = import.meta.env?.DEV ?? false;

// Development: Use local wrangler dev server
// Production: Use deployed Worker URL
export const API_BASE_URL = isDev 
  ? 'http://localhost:8787'
  : 'https://jetana-games.9246401ci.workers.dev'; // TODO: Update with your actual Worker URL

export const API_ENDPOINTS = {
  // Prediction endpoints
  predictions: {
    train: `${API_BASE_URL}/api/predictions/train`,
    trainAll: `${API_BASE_URL}/api/predictions/train-all`,
    generate: `${API_BASE_URL}/api/predictions/generate`,
    slots: `${API_BASE_URL}/api/predictions/slots`,
    coefficients: `${API_BASE_URL}/api/predictions/coefficients`,
    models: `${API_BASE_URL}/api/predictions/models`,
    accuracy: `${API_BASE_URL}/api/predictions/accuracy`,
    summary: `${API_BASE_URL}/api/predictions/summary`,
  },
} as const;
